import * as React from 'react';
import { safeHref } from './helper';

/**
 * Actions component.
 *
 * @param {Array} links
 * @returns {JSX.Element}
 * @constructor
 */
export const Actions = ({links}) => {
  if (links && Array.isArray(links) && links.length) {
    return <div className="fsf-result__actions fsf-result__links">
      {links.map((link, idx) => {
        const {url, target} = link;
        const href = safeHref(url);
        if (!href) {
          return null;
        }
        const linkAttr = {key: idx, href};
        if (target) {
          linkAttr.target = target;
          if (target === '_blank') {
            linkAttr.rel = 'noopener noreferrer';
          }
        }
        return <a {...linkAttr}>{link.text}</a>;
      })}
    </div>;
  }

  return <></>;
}
